export default __webpack_public_path__ + "static/media/Crusher.534c1eab.jpg";